<!--
<span class="cssload-container" *ngIf="loading">
    <div class="cssload-speeding-wheel"></div>
</span>
-->
<span class="cssload-container" *ngIf="loading">
    <i class="fa fa-refresh fa-spin fa-1x fa-fw"></i>
</span>
